export default __webpack_public_path__ + "static/media/SOEN.01d5f38d.png";